import React, { Component } from "react";
import { connect } from "react-redux";
import { updatePaintFinish, validatePaintFinish } from "../actions/";

class PaintFinish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validPaint: true,
      paintFinish: []
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.validPaint !== this.props.validPaint) {
      if (!this.props.validPaint) {
        this.setState({
          validPaint: false
        });
      } else {
        this.setState({
          validPaint: true
        });
      }
    }
    // if (this.props.winchType.orderCode !== prevProps.winchType.orderCode) {
    //   this.props.onPaintFinishSelect("");
    //   var ele = document.getElementsByName("paint_finish");
    //   for (var i = 0; i < ele.length; i++) ele[i].checked = false;
    // }
  }

  componentDidMount() {
    this.setState({
      paintFinish: [
        {
          value: "Primer",
          orderCode: "00"
        },
        {
          value: "RAL 9003 (white)",
          orderCode: "01"
        },
        {
          value: "RAL 9005 (black)",
          orderCode: "02"
        },
        {
          value: "RAL 9003 (white double coating)",
          orderCode: "03"
        },
        {
          value: "RAL 9005 (black double coating)",
          orderCode: "04"
        }
      ]
    });
  }

  handleOnchange = selected => {
    this.props.onPaintFinishSelect(JSON.parse(selected.target.value));
    this.props.validatePaintFinish(true);
  };

  render() {
    var paintFinish = this.state.paintFinish.map((pf, index) => {
      return (
        <div className="col-md-6" key={index}>
          <label>
            <input
              type="radio"
              value={JSON.stringify(pf)}
              name="paint_finish"
              defaultChecked={this.props.paintFinish.orderCode === pf.orderCode}
            />{" "}
            {pf.value}
          </label>
        </div>
      );
    });
    return (
      <div>
        <div className="field-top">Paint finish</div>
        <div className="selection-body">
          <p>Please select your paint finish:</p>
          {this.state.validPaint === false && (
            <p className="warning">Paint finsish is required.</p>
          )}
          <div className="row" onChange={this.handleOnchange}>
            {paintFinish}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pressureRoller: state.pressureRoller,
    winchType: state.winchType,
    previewStatus: state.previewStatus,
    paintFinish: state.paintFinish,
    validPaint: state.validPaint
  };
};

const mapActionsToProps = {
  onPaintFinishSelect: updatePaintFinish,
  validatePaintFinish: validatePaintFinish
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(PaintFinish);



// WEBPACK FOOTER //
// ./src/components/paintFinish.js